var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress, Grid, IconButton, InputAdornment } from '@mui/material';
import { TipoProcessoReqEnum } from '../../../../model/enums/TipoProcessoReqEnum';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { defaultMessageFieldError } from '../context/RequerimentoContext';
import { DefaultCard } from '../../../../components/DefaultCard';
import { SigadocApi } from '../../../../apis/sigadoc-api';
import { CustomInputForm } from '../../../../components/Forms/CustomInputForm';
import { CustomRadioGroup } from '../../../../components/Forms/CustomRadioGroup';
import { ShowContent } from '../../../../components/ShowContent';
import { DateSelector } from '../../../../components/DateSelector';
import { DateUtils } from '../../../../util/DateUtils';
import { HandleError } from '../../../utils/HandleError';
import { Search } from '@mui/icons-material';
var InputMask = require('react-input-mask');
var InputMaskAny = InputMask;
export var DadosImovelCopiaDig = function (_a) {
    var _b;
    var requerimento = _a.requerimento, requerimentoFieldError = _a.requerimentoFieldError, onChange = _a.onChange, onValidate = _a.onValidate, requerimentoFieldErrorChange = _a.requerimentoFieldErrorChange;
    // region Constants
    var SIGADOC_REGEX = /^INTERMAT-PRO-\d{4}\/\d{1,5}$/;
    var SAD_REGEX = /^\d{1,6}$/;
    var SIGADOC_MASK = 'INTERMAT-PRO-9999/99999';
    var SIGADOC_MAX_LENGTH = 23;
    var SIGADOC_PREFIX = 'INTERMAT-PRO-';
    var SIGADOC_PREFIX_LENGTH = SIGADOC_PREFIX.length;
    var startYear = 1900;
    var _c = useState(false), loadingValidation = _c[0], setLoadingValidation = _c[1];
    var ops = [
        { label: 'SIGADOC', value: TipoProcessoReqEnum.SIGADOC },
        { label: 'SAD', value: TipoProcessoReqEnum.SAD }
    ];
    var isSad = useMemo(function () {
        return (requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso) === TipoProcessoReqEnum.SAD;
    }, [requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso]);
    var _d = useState(true), numeroValido = _d[0], setNumeroValido = _d[1];
    var _e = useState(undefined), error = _e[0], setError = _e[1];
    useEffect(function () {
        var _a;
        onValidate === null || onValidate === void 0 ? void 0 : onValidate(handleValidate);
        if (!(requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso)) {
            onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, requerimento), { tipoProcesso: TipoProcessoReqEnum.SIGADOC }));
        }
        if ((requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso) === TipoProcessoReqEnum.SIGADOC &&
            !((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.numeroProcesso) === null || _a === void 0 ? void 0 : _a.startsWith(SIGADOC_PREFIX))) {
            onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, requerimento), { numeroProcesso: SIGADOC_PREFIX }));
        }
    }, [requerimento, numeroValido]);
    useEffect(function () {
        var _a, _b;
        if ((requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso) === TipoProcessoReqEnum.SIGADOC &&
            !((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.numeroProcesso) === null || _a === void 0 ? void 0 : _a.startsWith(SIGADOC_PREFIX))) {
            var currentValue = (_b = requerimento === null || requerimento === void 0 ? void 0 : requerimento.numeroProcesso) !== null && _b !== void 0 ? _b : '';
            if (currentValue.length < SIGADOC_PREFIX_LENGTH) {
                onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, requerimento), { numeroProcesso: SIGADOC_PREFIX }));
            }
        }
    }, [requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso, requerimento === null || requerimento === void 0 ? void 0 : requerimento.numeroProcesso]);
    //endregion
    //region Handles
    var handleNumeroProcessoChange = function (event) {
        var _a;
        var value = event.target.value;
        var novoAno = (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.anoProcesso) !== null && _a !== void 0 ? _a : null;
        var novoNumero = value.toUpperCase();
        if ((requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso) === TipoProcessoReqEnum.SIGADOC) {
            var _b = handleProccessSigadoc(novoNumero, novoAno), numero = _b.numero, ano = _b.ano;
            novoNumero = numero;
            novoAno = ano;
        }
        else if ((requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso) === TipoProcessoReqEnum.SAD) {
            novoNumero = handleProccessSad(value);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, requerimento), { numeroProcesso: novoNumero, anoProcesso: novoAno || (requerimento === null || requerimento === void 0 ? void 0 : requerimento.anoProcesso) }));
    };
    var handleProccessSigadoc = function (novoNumero, novoAno) {
        if (novoNumero.length < SIGADOC_PREFIX_LENGTH || !novoNumero.startsWith(SIGADOC_PREFIX)) {
            novoNumero = SIGADOC_PREFIX + novoNumero.substring(SIGADOC_PREFIX_LENGTH).replace(/[^0-9/]/g, '');
        }
        var match = /INTERMAT-PRO-(\d{4})\//.exec(novoNumero);
        if (match === null || match === void 0 ? void 0 : match[1]) {
            var anoNum = parseInt(match[1], 10);
            if (!isNaN(anoNum))
                novoAno = anoNum;
        }
        else {
            novoAno = null;
        }
        if (novoNumero.length < SIGADOC_MAX_LENGTH) {
            requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange(__assign(__assign({}, requerimentoFieldError), { numeroProcessoError: '' }));
        }
        return { numero: novoNumero, ano: novoAno };
    };
    var handleProccessSad = function (value) {
        var novoNumero = value.replace(/\D/g, '');
        if (novoNumero.length > 6) {
            novoNumero = novoNumero.substring(0, 6);
        }
        if (novoNumero.length <= 6) {
            requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange(__assign(__assign({}, requerimentoFieldError), { numeroProcessoError: '' }));
        }
        return novoNumero;
    };
    var handleValidate = function () {
        var hasTipoProcesso = !!(requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso);
        var isNumeroProcessoEmpty = !((requerimento === null || requerimento === void 0 ? void 0 : requerimento.numeroProcesso) && requerimento.numeroProcesso.trim().length > 0);
        var isValid = true;
        var errors = __assign({}, requerimentoFieldError);
        errors.tipoProcessoError = (hasTipoProcesso ? '' : defaultMessageFieldError);
        if (!hasTipoProcesso)
            isValid = false;
        errors.numeroProcessoError = isNumeroProcessoEmpty ? defaultMessageFieldError : (errors.numeroProcessoError || '');
        if (isNumeroProcessoEmpty) {
            isValid = false;
        }
        else {
            var _a = numeroProcessoNaoVazio(errors, isValid), _errors_1 = _a._errors, _isValid_1 = _a._isValid;
            errors = __assign({}, _errors_1);
            isValid = _isValid_1;
        }
        var _b = handleNumProccess(errors, isValid, isNumeroProcessoEmpty), _errors = _b._errors, _isValid = _b._isValid;
        errors = __assign({}, _errors);
        isValid = _isValid;
        requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange(errors);
        return isValid;
    };
    var numeroProcessoNaoVazio = function (errors, isValid) {
        var _a, _b;
        var cleanedNum = ((_b = (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.numeroProcesso) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : '');
        var isSigadocValid = ((requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso) === TipoProcessoReqEnum.SIGADOC) && SIGADOC_REGEX.test(cleanedNum);
        var isSadValid = ((requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso) === TipoProcessoReqEnum.SAD) && SAD_REGEX.test(cleanedNum);
        if ((requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso) === TipoProcessoReqEnum.SIGADOC && !isSigadocValid) {
            errors.numeroProcessoError = 'Formato SIGADOC inválido. (Ex: INTERMAT-PRO-2025/01234)';
            isValid = false;
        }
        if ((requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso) === TipoProcessoReqEnum.SAD && !isSadValid) {
            errors.numeroProcessoError = 'Formato SAD inválido. Máximo 6 dígitos numéricos.';
            isValid = false;
        }
        return { _errors: errors, _isValid: isValid };
    };
    var handleNumProccess = function (errors, isValid, isNumeroProcessoEmpty) {
        var _a;
        var anoProcessoErrorvalid = !!((_a = requerimentoFieldError === null || requerimentoFieldError === void 0 ? void 0 : requerimentoFieldError.anoProcessoError) !== null && _a !== void 0 ? _a : '');
        var hasAnoProcesso = !!(requerimento === null || requerimento === void 0 ? void 0 : requerimento.anoProcesso);
        if ((requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso) === TipoProcessoReqEnum.SAD) {
            errors.anoProcessoError = (hasAnoProcesso && !anoProcessoErrorvalid) ? '' : defaultMessageFieldError;
            if (!hasAnoProcesso || anoProcessoErrorvalid) {
                isValid = false;
            }
        }
        if (!numeroValido && (requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso) === TipoProcessoReqEnum.SIGADOC && !isNumeroProcessoEmpty) {
            errors.numeroProcessoError = errors.numeroProcessoError || 'Número informado não existe na base SIGADOC.';
            isValid = false;
        }
        return { _errors: errors, _isValid: isValid };
    };
    var onBlur = function () { return __awaiter(void 0, void 0, Promise, function () {
        var cleanValue, formatoValido, _error, matchGroups, ano, numero, numeroFormatado, _req, rawApiValue, response, isValidSigadoc, _ano;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ((requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso) !== TipoProcessoReqEnum.SIGADOC || !(requerimento === null || requerimento === void 0 ? void 0 : requerimento.numeroProcesso)) {
                        setNumeroValido(true);
                        return [2 /*return*/];
                    }
                    cleanValue = requerimento.numeroProcesso.trim();
                    formatoValido = SIGADOC_REGEX.test(cleanValue);
                    _error = __assign({}, requerimentoFieldError);
                    if (!formatoValido) {
                        _error.numeroProcessoError = 'Formato do número do processo inválido. (Ex: INTERMAT-PRO-2025/01234)';
                        setNumeroValido(false);
                        requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange(_error);
                        onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, requerimento), { anoProcesso: undefined }));
                        return [2 /*return*/];
                    }
                    matchGroups = /^INTERMAT-PRO-(\d{4})\/(\d{1,5})$/.exec(cleanValue);
                    if (!matchGroups) return [3 /*break*/, 2];
                    ano = matchGroups[1], numero = matchGroups[2];
                    numeroFormatado = "INTERMAT-PRO-".concat(ano, "/").concat(numero).toUpperCase();
                    _req = __assign(__assign({}, requerimento), { numeroProcesso: numeroFormatado });
                    setLoadingValidation(true);
                    rawApiValue = "INTERMATPRO".concat(ano).concat(numero);
                    return [4 /*yield*/, SigadocApi.validarCodSiga(rawApiValue)
                            .catch(function (err) { return setError(err); })
                            .finally(function () { return setLoadingValidation(false); })];
                case 1:
                    response = _a.sent();
                    _error = __assign(__assign({}, _error), { numeroProcessoError: ((response === null || response === void 0 ? void 0 : response.valido) === false ? 'Número informado não existe na base SIGADOC.' : '') });
                    isValidSigadoc = (response === null || response === void 0 ? void 0 : response.valido) !== false;
                    setNumeroValido(isValidSigadoc);
                    _ano = Number(ano);
                    if (isValidSigadoc && !isNaN(_ano)) {
                        if (validateYear(_ano, _error)) {
                            onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, _req), { anoProcesso: _ano }));
                        }
                        else {
                            onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, _req), { anoProcesso: undefined }));
                        }
                    }
                    else {
                        requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange(__assign({}, _error));
                        onChange === null || onChange === void 0 ? void 0 : onChange(__assign({}, _req));
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleYearChange = function (data) {
        var ano = DateUtils.getYear(data !== null && data !== void 0 ? data : undefined);
        onAnoChange(ano);
    };
    var onAnoChange = function (anoProcesso) {
        onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, requerimento), { anoProcesso: anoProcesso }));
        if (!anoProcesso)
            return;
        validateYear(anoProcesso, requerimentoFieldError);
    };
    var validateYear = function (anoProcesso, _err) {
        var anoProcessoStr = "".concat(anoProcesso);
        var currentYear = new Date().getFullYear();
        var errorMsg = '';
        if ((anoProcessoStr === null || anoProcessoStr === void 0 ? void 0 : anoProcessoStr.length) !== 4) {
            errorMsg = defaultMessageFieldError;
        }
        else if (anoProcesso < startYear) {
            errorMsg = "O ano do processo deve ser maior ou igual a ".concat(startYear, ".");
        }
        else if (anoProcesso > currentYear) {
            errorMsg = "O ano do processo deve ser menor ou igual ao ano atual (".concat(currentYear, ").");
        }
        else {
            errorMsg = "";
        }
        requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange(__assign(__assign({}, _err), { anoProcessoError: errorMsg }));
        return errorMsg === '';
    };
    var onTipoProcessoChange = function (tipoProcesso) {
        requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange(__assign(__assign({}, requerimentoFieldError), { numeroProcessoError: '', anoProcessoError: '' }));
        var novoNumero = '';
        if (tipoProcesso === TipoProcessoReqEnum.SIGADOC) {
            novoNumero = SIGADOC_PREFIX;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, requerimento), { tipoProcesso: tipoProcesso, numeroProcesso: novoNumero, anoProcesso: null }));
    };
    var inputAdorment = useCallback(function () {
        var _a;
        var isSigadocReadyToSearch = ((requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso) === TipoProcessoReqEnum.SIGADOC) && SIGADOC_REGEX.test((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.numeroProcesso) !== null && _a !== void 0 ? _a : '');
        if (!isSigadocReadyToSearch && !loadingValidation)
            return _jsx(_Fragment, {});
        return (_jsxs(InputAdornment, __assign({ position: "end" }, { children: [_jsx(ShowContent, __assign({ show: loadingValidation }, { children: _jsx(CircularProgress, { size: 20 }) })), _jsx(ShowContent, __assign({ show: !loadingValidation }, { children: _jsx(IconButton, __assign({ onClick: onBlur, edge: "end", disabled: !isSigadocReadyToSearch }, { children: _jsx(Search, {}) })) }))] })));
    }, [loadingValidation, requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso, requerimento === null || requerimento === void 0 ? void 0 : requerimento.numeroProcesso]);
    //endregion
    return (_jsxs(DefaultCard, __assign({ title: '' }, { children: [_jsxs(Grid, __assign({ container: true, spacing: 2, style: { padding: '15px' } }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, style: { marginBottom: '25px' } }, { children: _jsx(CustomRadioGroup, { onChange: function (event) { return onTipoProcessoChange(event.target.value); }, label: "Qual o tipo de protocolo do processo ?", value: requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso, name: "tipoProcesso", options: ops, required: true, collumn: true }) })), _jsxs(Grid, __assign({ item: true, xl: 6, lg: 6, md: 12, sm: 12, xs: 12 }, { children: [_jsx(ShowContent, __assign({ show: (requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso) === TipoProcessoReqEnum.SIGADOC }, { children: _jsx(CustomInputForm, { helperText: (requerimentoFieldError === null || requerimentoFieldError === void 0 ? void 0 : requerimentoFieldError.numeroProcessoError) || 'Ex: INTERMAT-PRO-2025/01234', error: !!(requerimentoFieldError === null || requerimentoFieldError === void 0 ? void 0 : requerimentoFieldError.numeroProcessoError) || (!!(requerimento === null || requerimento === void 0 ? void 0 : requerimento.numeroProcesso) && !numeroValido), placeholder: "INTERMAT-PRO-2025/01234", value: (requerimento === null || requerimento === void 0 ? void 0 : requerimento.numeroProcesso) || SIGADOC_PREFIX, onChange: handleNumeroProcessoChange, onBlur: onBlur, InputProps: {
                                        endAdornment: inputAdorment()
                                    }, inputProps: { maxLength: SIGADOC_MAX_LENGTH, maxlength: SIGADOC_MAX_LENGTH }, label: "N\u00FAmero do Processo", name: "numeroProcesso", fullWidth: true, required: true }) })), _jsx(ShowContent, __assign({ show: (requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoProcesso) === TipoProcessoReqEnum.SAD }, { children: _jsx(CustomInputForm, { helperText: (requerimentoFieldError === null || requerimentoFieldError === void 0 ? void 0 : requerimentoFieldError.numeroProcessoError) || 'Máximo 6 dígitos numéricos.', error: !!(requerimentoFieldError === null || requerimentoFieldError === void 0 ? void 0 : requerimentoFieldError.numeroProcessoError), placeholder: 'Informe o Número do Processo', value: (_b = requerimento === null || requerimento === void 0 ? void 0 : requerimento.numeroProcesso) !== null && _b !== void 0 ? _b : '', label: 'Número do Processo', onChange: handleNumeroProcessoChange, inputProps: { maxLength: 6, inputMode: 'numeric', pattern: '[0-9]*' }, name: "numeroProcesso", required: true, fullWidth: true }) }))] })), _jsx(Grid, __assign({ item: true, xl: 6, lg: 6, md: 12, sm: 12, xs: 12 }, { children: _jsx(DateSelector, { value: DateUtils.dataByYear(requerimento === null || requerimento === void 0 ? void 0 : requerimento.anoProcesso), minDate: new Date('1900-01-01 23:00'), placeholder: 'Informe o Ano do Processo', fieldError: requerimentoFieldError, onChange: handleYearChange, label: "Ano do Processo", inputFormat: 'YYYY', disableFuture: true, name: "anoProcesso", disabled: !isSad, required: isSad }) }))] })), _jsx(HandleError, { error: error, handleClose: function () { return setError(undefined); } })] })));
};
